


















import { cartModelProvider } from '../model'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      cartModel = cartModelProvider.inject()
    },
)
